import React, { useMemo } from 'react'
import PropTypes from 'prop-types'
import defaultEnv from '@maui-mf/env'
import { Header as BaseHeader } from '@maui/header'
import { api as authApi } from '@maui-mf/common-auth'
import { history } from '@maui-mf/common-history'
import { useAuthProvider } from '@maui-mf/common-react'
import { useEnvFeatures } from '../hooks'
import { ThreatProfilesMenu } from './ThreatProfilesMenu'
import { MatiApiClientProvider } from '@nautilusjs/mati-apis'

const onLinkClick = e => {
  if (e.target.host !== window.location.host) {
    return
  }
  e.preventDefault()
  history.push(e.target.href)
}

export const Header = ({ env }) => {
  const { token, userinfo, claims } = useAuthProvider()
  const features = useEnvFeatures(env)
  const { isl } = claims || {}
  const isFusionUser = isl?.includes('INTEL_RBI_FUS')
  const isSecOpsUser = !isFusionUser && isl?.includes('INTEL_RBI_OPS')
  const hasTPAccess = isFusionUser || isSecOpsUser

  const extendConfig = useMemo(() => {
    const hosts = {}

    if (env.ASM_HOST) {
      hosts.asm = env.ASM_HOST
    }

    if (env.MAUI_HOST) {
      hosts.ma = env.MAUI_HOST
    }

    if (env.MAAPI_HOST) {
      hosts.maApi = env.MAAPI_HOST
    }

    if (env.THREAT_PROFILE_API_HOST) {
      hosts.threatProfileApi = env.THREAT_PROFILE_API_HOST
    }

    return { hosts }
  }, [env])

  return (
    <BaseHeader
      config={env.MAUI_HEADER_CONFIG_URL}
      jwt={token}
      extendConfig={extendConfig}
      onLinkClick={onLinkClick}
      onSignOut={authApi.logoutRedirect}
      features={features}
      userinfo={userinfo?._raw}
      slotRight={
        hasTPAccess &&
        <MatiApiClientProvider
          origin={{
            maApiHost: extendConfig.hosts.maApi,
            threatProfilesApiHost: extendConfig.hosts.threatProfileApi
          }}
          threatProfilesPathPrefix={env.THREAT_PROFILE_API_PATH_PREFIX}
          token={token}
        >
          <ThreatProfilesMenu />
        </MatiApiClientProvider>
      }
    />
  )
}

Header.defaultProps = {
  env: defaultEnv,
}

Header.propTypes = {
  env: PropTypes.object,
}
